import { get, post, patch, del } from './client.js';

const base = (orgId) => `/orgs/${orgId}/roles`;

export const orgRolesApi = {
  list: (orgId) => get(base(orgId)),
  get: (orgId, roleId) => get(`${base(orgId)}/${roleId}`),
  create: (orgId, data) => post(base(orgId), data),
  update: (orgId, roleId, data) => patch(`${base(orgId)}/${roleId}`, data),
  remove: (orgId, roleId) => del(`${base(orgId)}/${roleId}`),
  duplicate: (orgId, roleId) => post(`${base(orgId)}/${roleId}/duplicate`),
  importRoles: (orgId, roles) => post(`${base(orgId)}/import`, { roles }),
  getEffectiveAccess: (orgId, memberId) => get(`${base(orgId)}/effective-access/${memberId}`),
};
